import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header";

const getAmortDetails = (state) => {
  return axios.get(API +"contracts/amorts-view/"+state+"/",{headers: authHeader(),});
};
const getAmortizationDetails = (state) => {
  return axios.get(API +"contracts/amortizationSchedule-view/"+state+"/",{headers: authHeader(),});
};

const ViewAmortService = {
    getAmortDetails,
    getAmortizationDetails
  };
  
export default ViewAmortService;